import { render, staticRenderFns } from "./PosCashReceipt.vue?vue&type=template&id=78a2047c&scoped=true"
import script from "./PosCashReceipt.vue?vue&type=script&lang=js"
export * from "./PosCashReceipt.vue?vue&type=script&lang=js"
import style0 from "./PosCashReceipt.vue?vue&type=style&index=0&id=78a2047c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2047c",
  null
  
)

export default component.exports